module.exports = "<div style=\"width: 100%;height: 100vh; overflow-y: hidden\">\r\n  <iframe style=\"width: 100%; height: 100vh;\" [src]=\"urlBoleto\">\r\n  </iframe>\r\n</div>"


//////////////////
// WEBPACK FOOTER
// C:/Disco D/Projetos/central-cliente/src/app/area-cliente/portal/tela-boleto/tela-boleto.component.html
// module id = ../../../../../src/app/area-cliente/portal/tela-boleto/tela-boleto.component.html
// module chunks = 1